import FormControl from "@mui/material/FormControl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListSubheader from "@mui/material/ListSubheader";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { useAppStore } from "../../store/appStore";

const Options = () => {
	const overallRankFilter = useAppStore((state) => state.overallRankFilter);
	const setOverallRankFilter = useAppStore(
		(state) => state.setOverallRankFilter
	);

	const handleChange = (event) => {
		if (event.target.name === "overallRankFilter") {
			setOverallRankFilter(event.target.value);
		}
	};

	return (
		<List subheader={<ListSubheader component="div">圖表選項</ListSubheader>}>
			<ListItem>
				<FormControl size="small" fullWidth>
					<InputLabel>入圍名單</InputLabel>
					<Select
						name="overallRankFilter"
						value={overallRankFilter}
						label="入圍名單"
						onChange={handleChange}
					>
						<MenuItem value="top-51">所有</MenuItem>
						<MenuItem value="top-30">30 強</MenuItem>
						<MenuItem value="top-21">21 強</MenuItem>
						<MenuItem value="top-18">18 強</MenuItem>
						<MenuItem value="top-16">16 強</MenuItem>
						<MenuItem value="top-14">14 強</MenuItem>
						<MenuItem value="top-12">12 強</MenuItem>
						<MenuItem value="top-10">10 強</MenuItem>
					</Select>
				</FormControl>
			</ListItem>
		</List>
	);
};

export default Options;
